import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  constructor(private auth:AuthService, private fs:AngularFirestore) { }

  orderSubInfoLength: number = null;
  
  confirmOrder(
    status:string,
    message:string,
    selectedmethod:string,
    brunch:string,
  )
{
return new Promise((resolve, reject)=> {
    this.fs.doc(`users/${this.auth.userId}`).update({brunch})
    this.fs.collection(`users/${this.auth.userId}/ordersubinfo`).add({
      status,
      message,
      selectedmethod,
    }).then(()=>resolve())
    this.fs.doc(`users/${this.auth.userId}`).update({
      gstatus:true
    })
  })
}

}
